import React, { useCallback } from "react";
import { Grid } from "@mui/material";
import ImageUploader from "./ImageUploader";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import IntentType from "../../../intentexecutor/utils/IntentType";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { Item } from "./styledComponent";
import { publishEvent } from "../../../components/generic/EventPublisher";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";

const ImageUploaderWrapper = ({ theme, setTheme, organizationIdentifier }) => {
  const user = useReadMemory(MemoryType.USER)
  const updateTheme = useCallback(
    (fieldName, url) => {
      const updateData = async (fieldName, url) => {
        const configurationValue = {
          ...theme,
          assets: {
            ...theme.assets,
            [fieldName]: url,
          },
        };

        const payload = {
          intent: "add_configuration",
          payload: {
            configurationKey: "niramaya.organization.theme",
            configurationValue: JSON.stringify(configurationValue),
          },
          context: {
            organizationIdentifier,
          },
        };

        try {
          const response = await performPostRequest(
            getApiUrl()[IntentType.ADD_CONFIGURATION],
            JSON.stringify(payload)
          );
          const result = await response.json();
          const themeValue = JSON.parse(result?.configurationValue || "{}");
          setTheme(themeValue);
          publishEvent("niramaya.organization.image.updated", user, themeValue, theme)
        } catch (error) {
          ErrorNotificationComponent(error);
        }
      };
      updateData(fieldName, url);
    },

    [setTheme, theme]
  );

  return (
    <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
      <Grid xs={12} item>
        <Item elevation={0}>
          <h6 className="add-edit-patient-sub-header">Upload Images</h6>
        </Item>
      </Grid>
      <ImageUploader
        label="Logo"
        dimensions="160x60"
        style={{
          maxWidth: 160,
          maxHeight: 60,
        }}
        updateTheme={updateTheme}
        initialImage={{ id: null, url: theme?.assets?.logo }}
      />
      <ImageUploader
        label="Favicon"
        dimensions="32x32"
        style={{
          width: 45,
          height: 45,
        }}
        updateTheme={updateTheme}
        initialImage={{ id: null, url: theme?.assets?.favicon }}
      />
    </Grid>
  );
};

export default ImageUploaderWrapper;
